import { ReactNode } from 'react';

import CloseIcon from '../../assets/icons/close.svg?react';
import ArrowModalIcon from '../../assets/icons/arrow-modal.svg?react';
import { Row } from '../Row/Row';
import {
	HeaderArrow,
	ModalBackdrop,
	ModalContainer,
	ModalContent,
	ModalHeader,
	ModalHeaderClose,
	ModalHeaderPrepend,
	ModalHeaderTitle
} from './style';

export interface ModalProps {
	show?: boolean;
	closeDisabled?: boolean;
	prepend?: ReactNode;
	title?: string;
	$fitToChildren?: boolean;
	children?: ReactNode;
	onClose?: () => void;
}

export function Modal({
	show = false,
	closeDisabled = false,
	$fitToChildren = false,
	prepend,
	title,
	children,
	onClose,
}: ModalProps) {
	return (
		<>
			{show && (
				<ModalBackdrop
					onClick={(e) => {
						if (closeDisabled) {
							return;
						}

						if (e.target !== e.currentTarget) {
							return;
						}

						if (onClose) {
							onClose();
						}
					}}
				>
					<ModalContainer>
						<ModalHeader>
							<Row $spaceBetween={true} $vcenter={true} $fillHeight={true}>
								<Row $gap={20} $vcenter={true}>
									{prepend && <ModalHeaderPrepend>{prepend}</ModalHeaderPrepend>}
									{title && <ModalHeaderTitle>{title}</ModalHeaderTitle>}
								</Row>
								{!closeDisabled && (
									<ModalHeaderClose
										onClick={() => {
											if (onClose) {
												onClose();
											}
										}}
									>
										<CloseIcon />
									</ModalHeaderClose>
								)}
							</Row>
							<HeaderArrow>
								<ArrowModalIcon />
							</HeaderArrow>
						</ModalHeader>
						<ModalContent $fitToChildren={$fitToChildren}>{children}</ModalContent>
					</ModalContainer>
				</ModalBackdrop>
			)}
		</>
	);
}
